  <template>
    <tr class="applicant-list">
      <td>
        <input
          type="checkbox"
          :value="jobseeker.id"
          @change="$emit('changed', jobseeker.id)"
          :checked="isChecked"
          style="width: 18px; height: 18px; margin-left: 5px;"
        />
      </td>
      <td @click="showProfile" style="text-align: left; min-width: 20px !important;">
        {{ index + 1 }}
      </td>
      <td @click="showProfile" style="text-align: left">
        <div class="content-cell" ref="contentCell">
          {{ truncatedContent }}
        </div>
      </td>
      <td @click="showProfile">{{ joinedDate }}</td>
      <td @click="showProfile">{{ jobseeker.age }}</td>
      <td @click="showProfile">{{ jobseeker.education.instituteName }}</td>
      <td @click="showProfile">{{ jobseeker.employment.lastCompany }}</td>
      <td @click="showProfile">
        {{ jobseeker.employment.lastJob.title }}
        <br />
        ( {{ jobseeker.employment.lastJob.child.title }} )
      </td>
      <td @click="showProfile">{{ jobseeker.employment.lastYearIncome }} 万円</td>
      <td>
        <div class="d-flex justify-content-end note-btn-grp">
          <Favorite
            :favorite="jobseeker.isFavorite"
            @click.native="toggleFavorite(jobseeker)"
            :toggledisabled="loading"
          />
          <Memo v-bind:key="jobseeker.id + jobseeker.memo" :applicant="jobseeker" />
        </div>
      </td>
      <td>
        <StatusBox :status="jobseeker.status" :isJDList="true"/>
      </td>
      <ProfileModal
        v-if="showProfileModal"
        :applicantId="jobseeker.id"
        :applicantIndex="index"
        :isFavorite="jobseeker.isFavorite"
        :isInterview="jobseeker.isInterview"
        :applicantdata="jobseeker"
        :showProfileModal="showProfileModal"
        v-on:hideModal="hideProfile"
      />
    </tr>
  </template>

  <script>
  import ApiService from '../../../service/apiService';
  import Api from '../../../config/api';
  import moment from 'moment';
  import Favorite from '@/components/dashboard/applicants/Favorite.vue';
  import StatusBox from '../contacts/contactLists/StatusBox.vue';
  import Memo from '@/components/dashboard/applicants/Memo.vue';
  import Loader from '../../utils/Loader.vue';
  import ProfileModal from '../applicants/profile/ProfileModal.vue';
  import { mapGetters, mapMutations } from 'vuex';
  export default {
    name: 'JDMatchingRow',
    data() {
      return {
        loading: false,
        showProfileModal: false,
        isOverflowing: false,
      };
    },
    components: {
      Memo,
      Favorite,
      Loader,
      StatusBox,
      ProfileModal,
    },
    props: {
      jobseeker: {
        type: Object,
      },
      index: {
        type: Number,
        required: true,
      },
      isChecked: {
        type: Boolean,
      },
    },
    methods: {
      ...mapMutations({
        mutateApplicantsAfterFav: 'mutateApplicantsAfterFav',
      }),
      showProfile() {
        this.showProfileModal = true;
      },
      hideProfile() {
        this.showProfileModal = false;
      },
      toggleFavorite(applicant) {
        this.loading = true;
        const method = applicant.isFavorite ? 'delete' : 'put';
        ApiService[method](Api.endpoints.FAVORITE(applicant.id))
          .then(({ data }) => {
            // this.applicantData = data.data;
            this.mutateApplicantsAfterFav(data.data);
          })
          .catch((err) => {
            console.log(err);
            this.parseErrorResponse(err.response);
          })
          .then(() => {
            this.loading = false;
          });
      },

    },
    computed: {
      ...mapGetters({
        statusColorMap: 'getStatusColorMap',
      }),
      joinedDate() {
        return moment(this.jobseeker.joinedDate)
          .utcOffset('+0900')
          .format('YYYY-MM-DD');
      },
      colorClass() {
        const status = this.jobseeker.status;
        const colorMap = this.statusColorMap;
        for (let color in colorMap) {
          if (colorMap[color].includes(status)) {
            return color;
          }
        }
        return '';
      },
      truncatedContent() {
        const content = this.jobseeker.employment.resumeContent || this.jobseeker.employment.summary;
        // if (!content) return '';
        
        // const lines = content.split('\n');
        // const maxLines = 11; // Show only 4 lines
        // console.log(lines);
        // if (lines.length > maxLines) {
        //   return lines.slice(0, maxLines).join('\n') + '...';
        // }
        return content;
      }
    },
  };
  </script>

  <style scoped>
  .applicant-list td {
    text-align: center;
    vertical-align: top;
    padding: 5px 3px !important;
  }

  .content-cell {
    white-space: pre-line;
    display: -webkit-box;
    -webkit-line-clamp: 11;  /* Number of lines to show */
    -webkit-box-orient: vertical;
    overflow: hidden;
    line-height: 2; 
    word-break: break-word;
    text-overflow: ellipsis;
    overflow-y: auto;
  }
  </style>